import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import arrowSelectImg from "../../assets/images/arrowSelect.png";
import {
  getGroupSettings,
  updateGroupSettings,
} from "../../redux/actions/groupSettings";
import { getAllSheetSettings } from "../../redux/actions/sheetSettings";
import { getAllWebhookSettings } from "../../redux/actions/webhookSettings";
import Loader from "../Loader";
import featherDownloadImg from "../../assets/images/Icon feather-download.png";
import downloadDark from "../../assets/images/downloadDark.png";
import { getGroupInfo } from "../../redux/actions/groupInfo";
import { downloadGroupmMembersCsv } from "../../services/extraServices";

const intialGroupSettings = {
  operationProcedure: {
    getGenderInfo: false,
    ifAllAnswered: false,
    sendMessageIfReqAccept: { value: false, messageGroup: null },
    sendMessageIfReqDecline: { value: false, messageGroup: null },
    autoDecline: { value: false, messageGroup: null },
    sendMessageForQuestion: {
      value: false,
      messageGroup: null,
      question: "",
      answer: "",
    },
    preApproveSheet: "",
    verifyEmail: "",
    emailQuestion: "",
    emailQuestionForPreApproved: "",
    delayTime: 0,
  },
  exportOption: {
    webhook: "",
    exportSheet: "",
    csvDownload: false,
  },
};

const GroupSettings = ({ groupFilter, groups, messageGroups }) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [preApproveSheetOpen, setpreApproveSheetOpen] = useState(false);
  const [invalidEmailAction, setInvalidEmailAction] = useState(false);
  const [webhookExportOption, setWebhookExportOption] = useState(false);
  const [googleSheetExportOption, setGoogleSheetExportOption] = useState(false);
  const [downloadCsvLoading, setDownloadCsvLoading] = useState(false);

  const [groupSettings, setGroupSettings] = useState({
    operationProcedure: {
      ...intialGroupSettings.operationProcedure,
      getGenderInfo: parseInt(userInfo?.planNo) === 5 ? true : false,
    },
    exportOption: {
      ...intialGroupSettings.exportOption,
    },
  });

  const sheetSettings = useSelector((state) => state.sheetSettings);
  const { loading, sheets } = sheetSettings;

  const webhookSettings = useSelector((state) => state.webhookSettings);
  const { loading: loadingWebhook, webhooks } = webhookSettings;

  const groupsettings = useSelector((state) => state.groupSettings);
  const { loading: loadingGroupSetings, groupSetting } = groupsettings;
  const leadList = useSelector((state) => state.leadList);
  const { leads, totalPage } = leadList;

  const [groupDestails, setGroupDestails] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    if (groupFilter) {
      // dispatch(getGroupInfo(1, groupFilter));
      dispatch(getAllSheetSettings());
      dispatch(getAllWebhookSettings());
      dispatch(getGroupSettings(groupFilter));
      if (groups) {
        setGroupDestails(groups.find((group) => group._id === groupFilter));
      }
    } else toast.error("Please select a group to get or add group settings !");
  }, [dispatch, groupFilter, groups, groupDestails]);

  useEffect(() => {
    if (groupSetting?.operationProcedure) {
      let gSettings = {
        operationProcedure: groupSetting.operationProcedure,
        exportOption: groupSetting.exportOption,
      };
      setGroupSettings(gSettings);
    } else {
      setGroupSettings({
        operationProcedure: {
          ...intialGroupSettings.operationProcedure,
          getGenderInfo: parseInt(userInfo?.planNo) === 5 ? true : false,
        },
        exportOption: {
          ...intialGroupSettings.exportOption,
        },
      });
    }

    setInvalidEmailAction((val) =>
      groupSetting?.operationProcedure?.verifyEmail ? true : false
    );
    setpreApproveSheetOpen((val) =>
      groupSetting?.operationProcedure?.preApproveSheet ? true : false
    );

    setGoogleSheetExportOption((val) =>
      groupSetting?.exportOption?.exportSheet ? true : false
    );

    setWebhookExportOption((val) =>
      groupSetting?.exportOption?.webhook ? true : false
    );
  }, [groupSetting, userInfo]);

  useEffect(() => {
    dispatch(getGroupInfo(1, groupFilter));
  }, [dispatch, groupFilter]);
  const submitHandler = () => {
    if (!groupFilter) {
      toast.error("Please choose your group!");
      return false;
    }
    if (
      preApproveSheetOpen &&
      (!groupSettings.operationProcedure.preApproveSheet ||
        !groupSettings.operationProcedure.emailQuestionForPreApproved)
    ) {
      toast.error("Please provide pre-approve sheet and email question!");
      toast.info(
        "If you unable to give email question input then please save your group memebership questions from facebook member request page and reload this page !"
      );
      return false;
    }

    if (
      invalidEmailAction &&
      (!groupSettings.operationProcedure.verifyEmail ||
        !groupSettings.operationProcedure.emailQuestion)
    ) {
      toast.error(
        "Please provide action for invalid email and email question !"
      );
      toast.info(
        "If you unable to give email question input then please save your group memebership questions from facebook member request page and reload this page !"
      );
      return false;
    }
    const delayTime = parseInt(groupSettings.operationProcedure?.delayTime);
    if (
      (groupSettings.operationProcedure?.sendMessageIfReqAccept?.value ||
        groupSettings.operationProcedure?.sendMessageIfReqDecline?.value ||
        groupSettings.operationProcedure?.sendMessageForQuestion?.value ||
        groupSettings.operationProcedure?.autoDecline?.value) &&
      (isNaN(delayTime) || Number(delayTime) < 0)
    ) {
      toast.error("Please enter default delay time for messaging!");
      return false;
    }

    if (
      groupSettings?.operationProcedure?.sendMessageIfReqAccept?.value &&
      !groupSettings?.operationProcedure?.sendMessageIfReqAccept.messageGroup
    ) {
      toast.error(
        "Please select a message group for send message if join request is accepted!"
      );
      return false;
    }
    if (
      groupSettings?.operationProcedure?.sendMessageIfReqDecline?.value &&
      !groupSettings?.operationProcedure?.sendMessageIfReqDecline.messageGroup
    ) {
      toast.error(
        "Please select a message group for send message if join request is declined!"
      );
      return false;
    }
    // if (
    //   groupSettings?.operationProcedure?.autoDecline?.value &&
    //   !groupSettings?.operationProcedure?.autoDecline.messageGroup
    // ) {
    //   toast.error(
    //     "Please select a message group for auto decline!"
    //   );
    //   return false;
    // }
    if (
      groupSettings?.operationProcedure?.sendMessageForQuestion?.value &&
      (!groupSettings?.operationProcedure?.sendMessageForQuestion
        .messageGroup ||
        !groupSettings?.operationProcedure?.sendMessageForQuestion.question ||
        !groupSettings?.operationProcedure?.sendMessageForQuestion.answer)
    ) {
      toast.error(
        "Please fill complete details for Send message only for specific question!"
      );
      return false;
    }

    if (webhookExportOption && !groupSettings.exportOption.webhook) {
      toast.error("Please provide webhook to export your data !");
      return false;
    }

    if (googleSheetExportOption && !groupSettings.exportOption.exportSheet) {
      toast.error("Please provide spreadsheet to export your data !");
      return false;
    }

    if (
      !groupSettings.exportOption.webhook &&
      !groupSettings.exportOption.exportSheet &&
      !groupSettings.exportOption.csvDownload
    ) {
      toast.error("Please select atleast one export option  !");
      return false;
    }
    if (
      groupSettings.operationProcedure?.autoDecline?.value &&
      !groupSettings.operationProcedure?.ifAllAnswered &&
      !preApproveSheetOpen &&
      !invalidEmailAction
    ) {
      toast.error(
        `Please select at least one of these three options for auto-decline! \n 1.Only approve if answered all questions. \n
        2.Only approve if pre-approved. \n 3.Verify email address.`
      );
      return false;
    }

    dispatch(updateGroupSettings(groupFilter, groupSettings));
  };

  const resetSettings = () => {
    setGroupSettings({
      operationProcedure: {
        ...intialGroupSettings.operationProcedure,
        getGenderInfo: parseInt(userInfo?.planNo) === 5 ? true : false,
      },
      exportOption: {
        ...intialGroupSettings.exportOption,
      },
    });
    setInvalidEmailAction(false);
    setpreApproveSheetOpen(false);
    setGoogleSheetExportOption(false);
    setWebhookExportOption(false);
  };
  // console.log("invalidEmailAction", invalidEmailAction)

  // console.log("groupSetting", groupSettings)

  return (
    <div id="tab-3" className="tab-content webhookTabs customizeHeights">
      {loading || loadingWebhook || loadingGroupSetings ? <Loader /> : ""}
      <div className="groupSettingsTabContent tabContentGroup customizeDesign">
        <h4 className="groupSettingsHeading">
          Please tell us how you want to proceed?
        </h4>
        {/* <span className="border_span"></span> */}

        <div className="indRowCheckOptions firstRowContent">
          <div className="individualCheckBox firstRows firstCoulmn">
            <label className="checkBoxText">
              Get Gender, Country, Tier
              <input
                type="checkbox"
                checked={groupSettings["operationProcedure"]["getGenderInfo"]}
                onChange={() => {
                  if (userInfo.planNo < 5) {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                        getGenderInfo: false,
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                      },
                    });
                    toast.info(
                      "Please upgrade your account to get gender, country & tier info of a member !"
                    );
                  } else {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                        getGenderInfo:
                          !groupSettings["operationProcedure"]["getGenderInfo"],
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                      },
                    });
                  }
                }}
              />
              <span className="checkmark"></span>
            </label>
          </div>

          <div className="individualCheckBox secondRows firstCoulmn">
            <label className="checkBoxText">
              Only approve if answered all questions
              <input
                type="checkbox"
                checked={groupSettings.operationProcedure?.ifAllAnswered}
                onChange={(e) => {
                  setGroupSettings({
                    operationProcedure: {
                      ...groupSettings.operationProcedure,
                      ifAllAnswered:
                        !groupSettings["operationProcedure"]["ifAllAnswered"],
                    },
                    exportOption: {
                      ...groupSettings.exportOption,
                    },
                  });
                }}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>

        <div className="indRowCheckOptions">
          <div className="checkboxWraper secondRow">
            <div className="individualCheckBox firstRows secondColumn">
              <label className="checkBoxText">
                Send message only for specific question:
                <input
                  type="checkbox"
                  checked={
                    groupSettings.operationProcedure?.sendMessageForQuestion
                      ?.value
                  }
                  onChange={(e) => {
                    if (userInfo.planNo < 5) {
                      toast.info(
                        "Please upgrade your account to use messaging feature!"
                      );
                    } else {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageForQuestion: {
                            ...groupSettings.operationProcedure
                              ?.sendMessageForQuestion,
                            value:
                              !groupSettings["operationProcedure"][
                                "sendMessageForQuestion"
                              ]["value"],
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div
              className={
                groupSettings?.operationProcedure?.sendMessageForQuestion?.value
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  {/* <img src={arrowSelectImg} className='arrowIngDrop' alt='' /> */}
                  <select
                    className="dropSelect"
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageForQuestion: {
                            ...groupSettings.operationProcedure
                              ?.sendMessageForQuestion,
                            messageGroup:
                              e.target.value === "" || !e.target.value
                                ? null
                                : e.target.value,
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                    value={
                      groupSettings?.operationProcedure?.sendMessageForQuestion
                        ?.messageGroup || ""
                    }
                  >
                    <option value="">Select Message Group</option>
                    {messageGroups?.map((messageGroup) => {
                      return (
                        <option key={messageGroup._id} value={messageGroup._id}>
                          {messageGroup.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </span>
            </div>
            <div
              className={
                groupSettings?.operationProcedure?.sendMessageForQuestion?.value
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              {/* {groupSettings?.operationProcedure?.sendMessageForQuestion
							?.value && ( */}
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  <select
                    className="dropSelect"
                    value={
                      groupSettings?.operationProcedure?.sendMessageForQuestion
                        ?.question
                    }
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageForQuestion: {
                            ...groupSettings.operationProcedure
                              ?.sendMessageForQuestion,
                            question: e.target.value,
                            answer: "",
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                  >
                    <option value="">Select a valid question</option>
                    {groupDestails.membershipQuestions &&
                      groupDestails.membershipQuestions.length > 0 &&
                      groupDestails.membershipQuestions
                        .filter(
                          (item) => item.questionType === "MULTIPLE_CHOICE"
                        )
                        .map((question, index) => {
                          return (
                            <option key={question.id} value={question.id}>
                              {question.question}
                            </option>
                          );
                        })}
                  </select>
                </div>
              </span>
            </div>
            <div
              className={
                groupSettings?.operationProcedure?.sendMessageForQuestion?.value
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  <select
                    className="dropSelect"
                    value={
                      groupSettings?.operationProcedure?.sendMessageForQuestion
                        ?.answer
                    }
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageForQuestion: {
                            ...groupSettings.operationProcedure
                              ?.sendMessageForQuestion,
                            answer: e.target.value,
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                  >
                    <option value="">Select a valid answer</option>
                    {groupDestails.membershipQuestions
                      ?.find(
                        (question) =>
                          question.id ===
                          groupSettings?.operationProcedure
                            ?.sendMessageForQuestion?.question
                      )
                      ?.options?.map((option, index) => {
                        return (
                          <option key={option.optionId} value={option.optionId}>
                            {option.value}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div className="indRowCheckOptions">
          <div className="checkboxWraper">
            <div className="individualCheckBox firstRows secondColumn">
              <label className="checkBoxText">
                Only approve if pre-approved
                <input
                  type="checkbox"
                  checked={preApproveSheetOpen}
                  onChange={(e) => {
                    if (userInfo.planNo < 3) {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          preApproveSheet: "",
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                      setpreApproveSheetOpen(false);
                      toast.info(
                        "Please upgrade your account to use pre-approve feature !"
                      );
                    } else {
                      if (e.target.checked === false) {
                        setGroupSettings({
                          operationProcedure: {
                            ...groupSettings.operationProcedure,
                            preApproveSheet: "",
                          },
                          exportOption: {
                            ...groupSettings.exportOption,
                          },
                        });
                      }
                      setpreApproveSheetOpen(e.target.checked);
                    }
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div
              className={
                preApproveSheetOpen
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  {/* <img src={arrowSelectImg} className='arrowIngDrop' alt='' /> */}
                  <select
                    className="dropSelect"
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          preApproveSheet: e.target.value,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                    value={
                      groupSettings?.operationProcedure?.preApproveSheet || ""
                    }
                  >
                    <option value="">Select google sheet</option>
                    {sheets &&
                      sheets
                        .filter((sheet) => sheet.type === "preApprove")
                        .map((sheet) => {
                          return (
                            <option key={sheet._id} value={sheet._id}>
                              {sheet.spreadsheetTitle}
                            </option>
                          );
                        })}
                  </select>
                </div>
              </span>
            </div>

            <div
              className={
                preApproveSheetOpen
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  <select
                    className="dropSelect"
                    value={
                      groupSettings?.operationProcedure
                        ?.emailQuestionForPreApproved
                    }
                    onChange={(e) =>
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          emailQuestionForPreApproved: e.target.value,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      })
                    }
                  >
                    <option value="">Select Your Email Question</option>
                    {groupDestails.membershipQuestions &&
                      groupDestails.membershipQuestions.length > 0 &&
                      groupDestails.membershipQuestions.map(
                        (question, index) => {
                          return (
                            <option key={question.id} value={question.id}>
                              {question.question}
                            </option>
                          );
                        }
                      )}
                  </select>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div className="indRowCheckOptions">
          <div className="checkboxWraper secondRow">
            <div className="individualCheckBox secondRows secondColumn">
              <label className="checkBoxText">
                Verify Email address
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (userInfo.planNo < 4) {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          verifyEmail: "",
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                      setInvalidEmailAction(false);
                      toast.info(
                        "Please upgrade your account to use email verification feature !"
                      );
                    } else {
                      if (e.target.checked === false) {
                        setGroupSettings({
                          operationProcedure: {
                            ...groupSettings.operationProcedure,
                            verifyEmail: "",
                          },
                          exportOption: {
                            ...groupSettings.exportOption,
                          },
                        });
                      }
                      setInvalidEmailAction(e.target.checked);
                    }
                  }}
                  checked={invalidEmailAction}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div
              className={
                invalidEmailAction
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions activated">
                <div className="selectWraper drpOptions">
                  <select
                    className="dropSelect"
                    onChange={(e) => {
                      if (userInfo.planNo < 4) {
                        setGroupSettings({
                          operationProcedure: {
                            ...groupSettings.operationProcedure,
                            verifyEmail: "",
                          },
                          exportOption: {
                            ...groupSettings.exportOption,
                          },
                        });
                        setInvalidEmailAction(false);
                        toast.info(
                          "Please upgrade your account to use email verification feature !"
                        );
                      } else {
                        setGroupSettings({
                          operationProcedure: {
                            ...groupSettings.operationProcedure,
                            verifyEmail: e.target.value,
                          },
                          exportOption: {
                            ...groupSettings.exportOption,
                          },
                        });
                      }
                    }}
                    value={groupSettings?.operationProcedure?.verifyEmail || ""}
                  >
                    <option value="">Select action for invalid Email</option>
                    <option value="skip">Don't approve the request</option>
                    <option value="decline">Decline the request</option>
                  </select>
                </div>
              </span>
            </div>

            <div
              className={
                invalidEmailAction
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  <select
                    className="dropSelect"
                    value={groupSettings?.operationProcedure?.emailQuestion}
                    onChange={(e) =>
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          emailQuestion: e.target.value,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      })
                    }
                  >
                    <option value="">Select Your Email Question</option>
                    {groupDestails.membershipQuestions &&
                      groupDestails.membershipQuestions.length > 0 &&
                      groupDestails.membershipQuestions.map(
                        (question, index) => {
                          return (
                            <option key={question.id} value={question.id}>
                              {question.question}
                            </option>
                          );
                        }
                      )}
                  </select>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div className="indRowCheckOptions">
          <div className="checkboxWraper secondRow">
            <div className="individualCheckBox firstRows secondColumn">
              <label className="checkBoxText">
                Send message if join request is accepted:
                <input
                  type="checkbox"
                  checked={
                    groupSettings.operationProcedure?.sendMessageIfReqAccept
                      ?.value
                  }
                  onChange={(e) => {
                    if (userInfo.planNo < 5) {
                      toast.info(
                        "Please upgrade your account to use messaging feature!"
                      );
                    } else {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageIfReqAccept: {
                            ...groupSettings.operationProcedure
                              ?.sendMessageIfReqAccept,
                            value:
                              !groupSettings["operationProcedure"][
                                "sendMessageIfReqAccept"
                              ]["value"],
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div
              className={
                groupSettings.operationProcedure?.sendMessageIfReqAccept?.value
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  {/* <img src={arrowSelectImg} className='arrowIngDrop' alt='' /> */}
                  <select
                    className="dropSelect"
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageIfReqAccept: {
                            ...groupSettings?.operationProcedure
                              ?.sendMessageIfReqAccept,
                            messageGroup:
                              e.target.value === "" || !e.target.value
                                ? null
                                : e.target.value,
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                    value={
                      groupSettings?.operationProcedure?.sendMessageIfReqAccept
                        ?.messageGroup || ""
                    }
                  >
                    <option value="">Select Message Group</option>
                    {messageGroups?.map((messageGrup) => {
                      return (
                        <option key={messageGrup._id} value={messageGrup._id}>
                          {messageGrup.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div className="indRowCheckOptions">
          <div className="checkboxWraper secondRow">
            <div className="individualCheckBox firstRows secondColumn">
              <label className="checkBoxText">
                Send message if join request is declined:
                <input
                  type="checkbox"
                  checked={
                    groupSettings.operationProcedure?.sendMessageIfReqDecline
                      ?.value
                  }
                  onChange={(e) => {
                    if (userInfo.planNo < 5) {
                      toast.info(
                        "Please upgrade your account to use messaging feature!"
                      );
                    } else {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageIfReqDecline: {
                            ...groupSettings.operationProcedure
                              ?.sendMessageIfReqDecline,
                            value:
                              !groupSettings["operationProcedure"][
                                "sendMessageIfReqDecline"
                              ]["value"],
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div
              className={
                groupSettings.operationProcedure?.sendMessageIfReqDecline?.value
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  {/* <img src={arrowSelectImg} className='arrowIngDrop' alt='' /> */}
                  <select
                    className="dropSelect"
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          sendMessageIfReqDecline: {
                            ...groupSettings?.operationProcedure
                              ?.sendMessageIfReqDecline,
                            messageGroup:
                              e.target.value === "" || !e.target.value
                                ? null
                                : e.target.value,
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                    value={
                      groupSettings?.operationProcedure?.sendMessageIfReqDecline
                        ?.messageGroup || ""
                    }
                  >
                    <option value="">Select Message Group</option>
                    {messageGroups?.map((messageGrup) => {
                      return (
                        <option key={messageGrup._id} value={messageGrup._id}>
                          {messageGrup.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div className="indRowCheckOptions">
          <div className="checkboxWraper secondRow">
            <div className="individualCheckBox firstRows secondColumn">
              <label className="checkBoxText">
                Auto decline members:
                <input
                  type="checkbox"
                  checked={groupSettings.operationProcedure?.autoDecline?.value}
                  onChange={(e) => {
                    if (userInfo.planNo < 5) {
                      toast.info(
                        "Please upgrade your account to use messaging feature !"
                      );
                    } else {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          autoDecline: {
                            ...groupSettings.operationProcedure?.autoDecline,
                            value:
                              !groupSettings["operationProcedure"][
                                "autoDecline"
                              ]["value"],
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div
              className={
                groupSettings.operationProcedure?.autoDecline?.value
                  ? "individualCheckBox selectDropsOnly"
                  : "individualCheckBox selectDropsOnly disabled"
              }
            >
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  {/* <img src={arrowSelectImg} className='arrowIngDrop' alt='' /> */}
                  <select
                    className="dropSelect"
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          autoDecline: {
                            ...groupSettings?.operationProcedure?.autoDecline,
                            messageGroup:
                              e.target.value === "" || !e.target.value
                                ? null
                                : e.target.value,
                          },
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                    value={
                      groupSettings?.operationProcedure?.autoDecline
                        ?.messageGroup || ""
                    }
                  >
                    <option value="">Select Message Group</option>
                    {messageGroups?.map((messageGrup) => {
                      return (
                        <option key={messageGrup._id} value={messageGrup._id}>
                          {messageGrup.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div className="indRowCheckOptions" style={{ flexDirection: "column" }}>
          <div
            className="checkboxWraper secondRow"
            style={{ paddingBottom: "7px" }}
          >
            <div className="individualCheckBox firstRows secondColumn">
              <label className="checkBoxText" style={{ paddingLeft: 0 }}>
                Default delay time for messaging (In seconds):
              </label>
            </div>
            <div className="individualCheckBox selectDropsOnly">
              <span className="dropdownOptions onlySelectsOptions">
                <div className="selectWraper drpOptions">
                  <input
                    className="dropSelect delayTimimg message-segment-input bg-transparent"
                    type="number"
                    min="0"
                    style={{
                      padding: "11px 20px",
                      marginBottom: "0",
                      height: "40px",
                    }}
                    placeholder="E.g. 30"
                    value={groupSettings?.operationProcedure?.delayTime}
                    onChange={(e) => {
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                          delayTime: e.target.value,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                        },
                      });
                    }}
                  />
                </div>
              </span>
            </div>
          </div>
          <span
            style={{
              fontSize: "10px",
              color: "gray",
              width: "100%",
              float: "left",
              paddingLeft: "20px",
            }}
          >
            *Note: By default there will be a 60 seconds random delay
          </span>
        </div>

        {/* <div className="exportSection">
          <span className="border-line"></span>
          <span className="exportHeading">Export Options</span>
        </div> */}
        <h4
          className="groupSettingsHeading exports"
          style={{ paddingTop: "20px" }}
        >
          Export options
        </h4>

        <div className="indRowCheckOptions">
          <div className="individualExpots">
            <span className="checkOptions exportOptions">
              <label className="checkBoxText">
                Download as CSV
                <input
                  checked={groupSettings?.exportOption?.csvDownload}
                  type="checkbox"
                  onChange={(e) => {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                        csvDownload:
                          !groupSettings["exportOption"]["csvDownload"],
                      },
                    });
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </span>
            <button
              className="secondBtn gmNewBtn csvBtn tabBtns"
              disabled={downloadCsvLoading}
              onClick={async () => {
                setDownloadCsvLoading(true);
                await downloadGroupmMembersCsv(
                  groupFilter,
                  groupDestails?.groupName || "Group",
                  userInfo
                );
                setDownloadCsvLoading(false);
              }}
              style={{ width: "188px", marginLeft: "20px" }}
            >
              {/* <img src={downloadDark} className="tabBtnImgs" alt="" />{" "} */}
              {downloadCsvLoading ? "Downloading..." : "Download CSV Now"}
            </button>
          </div>
        </div>
        <div className="indRowCheckOptions">
          <div className="individualExpots">
            <span className="checkOptions exportOptions">
              <label className="checkBoxText">
                Send data to Webhook
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setWebhookExportOption(e.target.checked);
                    !e.target.checked &&
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                          webhook: "",
                        },
                      });
                  }}
                  checked={webhookExportOption}
                />
                <span className="checkmark"></span>
              </label>
            </span>
            <span className="dropdownOptions exportOptions">
              <div className="selectWraper">
                <select
                  disabled={!webhookExportOption ? true : false}
                  value={groupSettings["exportOption"]["webhook"] || ""}
                  onChange={(e) => {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                        webhook: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="">Select webhook to send exported data</option>
                  {webhooks &&
                    webhooks.map((web) => {
                      return (
                        <option key={web._id} value={web._id}>
                          {web.title}
                        </option>
                      );
                    })}
                </select>
              </div>
            </span>
          </div>
        </div>
        <div className="indRowCheckOptions">
          <div className="individualExpots">
            <span className="checkOptions exportOptions">
              <label className="checkBoxText">
                Send data to Google Sheet
                <input
                  type="checkbox"
                  checked={googleSheetExportOption}
                  onChange={(e) => {
                    setGoogleSheetExportOption(e.target.checked);
                    !e.target.checked &&
                      setGroupSettings({
                        operationProcedure: {
                          ...groupSettings.operationProcedure,
                        },
                        exportOption: {
                          ...groupSettings.exportOption,
                          exportSheet: "",
                        },
                      });
                  }}
                />
                <span className="checkmark"></span>
              </label>
            </span>
            <span className="dropdownOptions exportOptions">
              <div className="selectWraper">
                <select
                  disabled={!googleSheetExportOption ? true : false}
                  onChange={(e) => {
                    setGroupSettings({
                      operationProcedure: {
                        ...groupSettings.operationProcedure,
                      },
                      exportOption: {
                        ...groupSettings.exportOption,
                        exportSheet: e.target.value,
                      },
                    });
                  }}
                  value={groupSettings?.exportOption?.exportSheet || ""}
                >
                  <option value="">Select google sheet to export</option>
                  {sheets &&
                    sheets
                      .filter((sheet) => sheet.type === "export")
                      .map((sheet) => {
                        return (
                          <option key={sheet._id} value={sheet._id}>
                            {sheet.spreadsheetTitle}
                          </option>
                        );
                      })}
                </select>
              </div>
            </span>
          </div>
        </div>

        <div
          className="tabHeadingText groupSettings"
          style={{ marginTop: "45px" }}
        >
          <div
            className="actionBttons buttonWraper customizeWraper"
            style={{ width: "auto", padding: "0" }}
          >
            <button
              className="cancelBtn resetBtn tabBtns"
              disabled={!groupFilter ? true : false}
              onClick={resetSettings}
            >
              Reset
            </button>
            <button
              className="confirmBtn groupSubmit tabBtns"
              onClick={submitHandler}
              disabled={!groupFilter ? true : false}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupSettings;
